import { animate, style, transition, trigger } from '@angular/animations';
import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';

@Component({
  selector: 'app-header-notification',
  templateUrl: './header-notification.component.html',
  styleUrls: ['./header-notification.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [
    trigger('inFromTop', [
      transition(':enter', [
        style({
          transform: 'translateY(-100%)',
        }),
        animate(
          '250ms ease-out',
          style({
            transform: '*',
          }),
        ),
      ]),
    ]),
  ],
})
export class HeaderNotificationComponent implements OnInit {
  @Input()
  type: 'notification' | 'message' | 'warning' | 'error' = 'message';

  @Output()
  dismissClick = new EventEmitter();

  constructor() {}

  ngOnInit(): void {}

  handleDismissClicked() {
    this.dismissClick.emit();
  }
}
